
import { useState } from 'react';
import { OrchestrationInsights } from '@/components/ai/types';
import { Message } from '@/components/ai/types';

interface UseOrchestrationPipelineProps {
  setActiveAgents: (agents: string[]) => void;
  setOrchestrationInsights: (insights: OrchestrationInsights | null) => void;
  setPendingClarification: (pending: boolean) => void;
}

export function useOrchestrationPipeline({
  setActiveAgents,
  setOrchestrationInsights,
  setPendingClarification
}: UseOrchestrationPipelineProps) {
  const [userResponses, setUserResponses] = useState<Record<string, string>>({});

  const processUserInput = async (input: string, messageCallback?: (message: Message) => void): Promise<boolean> => {
    try {
      // Process user input and update orchestration insights
      // This is where you would implement the actual orchestration logic
      
      // Example of setting proper orchestration insights
      setOrchestrationInsights({
        activeAgents: 2,
        taskComplexity: 'moderate',
        estimatedCompletion: new Date(Date.now() + 300000), // 5 minutes from now
        confidence: 0.85,
        reasoning: 'Processing user request with multiple agents'
      });

      // Set active agents
      setActiveAgents(['executive-agent', 'scheduling-agent']);

      // If a message callback is provided, use it
      if (messageCallback) {
        const aiMessage: Message = {
          id: (Date.now() + 1).toString(),
          content: `Processing your request: "${input}"`,
          sender: "ai",
          timestamp: new Date(),
        };
        messageCallback(aiMessage);
      }

      return true; // Indicate successful processing
    } catch (error) {
      console.error('Error in processUserInput:', error);
      return false;
    }
  };

  return {
    processUserInput,
    userResponses,
    setUserResponses
  };
}
